export default __webpack_public_path__ + "static/media/1394.e46044a5.png";